export class RouteStatus {
  RouteId: string;
  RouteStatus: string;
  RouteDate: Date;
}
